import { BusStop, IRtnTripAsNumber } from '@/types/logs'

export const calculateMileage = (
    selectedStops: BusStop[],
    selectedTrips: IRtnTripAsNumber[],
    fromStopNumber: string,
    fromDirection?: string
): string => {
    const outboundStops = selectedStops.filter((stop) => stop.direction === 'outbound')
    const inboundStops = selectedStops.filter((stop) => stop.direction === 'inbound')

    const outboundMileageLoss = outboundStops
        .filter((busStop) => busStop.stopNumber !== fromStopNumber || busStop.direction !== fromDirection)
        .reduce((sum, stop) => sum + stop.miles, 0)

    const inboundMileageLoss = inboundStops
        .filter((busStop) => busStop.stopNumber !== fromStopNumber || busStop.direction !== fromDirection)
        .reduce((sum, stop) => sum + stop.miles, 0)

    const affectedOutboundTrips = selectedTrips.filter((trip) => trip.direction === 'o').length || 1
    const affectedInboundTrips = selectedTrips.filter((trip) => trip.direction === 'i').length || 1

    const totalMileageLoss = affectedOutboundTrips * outboundMileageLoss + affectedInboundTrips * inboundMileageLoss

    return totalMileageLoss.toFixed(2)
}
